<template>
  <div>
    <InstitutionListSkeleton v-if="isLoading" />
    <div v-else id="InstitutionList" class="institutions-list">
      <h2 class="institutions-list-title">
        {{ institutions.length }} resultados encontrados
      </h2>
      <div class="doctors-list-columns two-columns">
        <div v-for="institution in institutions" :key="institution.id">
          <InstitutionListCard
            :institution="institution"
            :institution-type="entity"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import InstitutionListCard from "./InstitutionListCard.vue";
import InstitutionListSkeleton from "./InstitutionListSkeleton.vue";

export default {
  name: "InstitutionList",
  components: {
    InstitutionListCard,
    InstitutionListSkeleton
  },
  props: {
    entity: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isLoading: false,
      institutions: []
    };
  },
  mounted() {
    this.getInstitutions();
  },
  methods: {
    ...mapActions("institutions", ["fetchInstitutions"]),

    async getInstitutions() {
      try {
        this.isLoading = true;
        let params = {
          institution_type:
            this.entity == "public_institutions"
              ? "public_institution"
              : "private_institution"
        };
        const institutions = await this.fetchInstitutions(params);
        this.institutions = institutions.data;
      } catch {
        this.$toast.error(
          "Erro ao carregar clínicas, tente novamente mais tarde!"
        );
      } finally {
        this.isLoading = false;
      }
    }
  },

  watch: {
    entity(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getInstitutions();
      }
    }
  }
};
</script>
